import { Link } from "react-router-dom";
import { contractDocuments } from "../content/contractsRegistry.js";

export default function ContractsIndexPage() {
  return (
    <article className="site-page">
      <div className="site-page__inner">
        <aside className="disclaimer-banner" role="note">
          <strong>Legal disclaimer.</strong> These drafts are starting points only.
          They are <strong>not</strong> legal advice. Have a licensed California
          attorney tailor and approve every clause before signing.
        </aside>

        <p className="site-page__eyebrow">Agreements</p>
        <h1 className="site-page__title">Sample engagement drafts</h1>
        <p className="site-page__lead">
          Use these Markdown templates internally and with prospects as discussion
          artifacts. Replace bracketed placeholders, delete instructional lines,
          and route final PDFs through counsel.
        </p>

        <ul className="contracts-index-list">
          {contractDocuments.map((doc) => (
            <li key={doc.slug}>
              <Link to={`/contracts/${doc.slug}`}>{doc.title}</Link>
              {" - "}
              {doc.summary}
            </li>
          ))}
        </ul>

        <p className="site-page__muted">
          <Link to="/pricing">← Back to pricing</Link>
        </p>
      </div>
    </article>
  );
}
